import { render, staticRenderFns } from "./CardDescriptionTable.vue?vue&type=template&id=334333c6&scoped=true"
import script from "./CardDescriptionTable.vue?vue&type=script&lang=js"
export * from "./CardDescriptionTable.vue?vue&type=script&lang=js"
import style0 from "./CardDescriptionTable.vue?vue&type=style&index=0&id=334333c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334333c6",
  null
  
)

export default component.exports